export enum MessagesTypes {
  FETCH_MESSAGES_SUCCESS = "FETCH_MESSAGES_SUCCESS",
  FETCH_MESSAGES_FAILURE = "FETCH_MESSAGES_FAILURE",
  FETCH_MESSAGES_REQUEST = "FETCH_MESSAGES_REQUEST"
}